// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace NormalizedExpression {
  export type Value =
    | string
    | number
    | boolean
    | null
    | { version: string }
    | undefined;

  export type BinaryOperator = '=' | '!=' | '>' | '>=' | '<' | '<=';

  export type UnaryOperator = 'is-null' | 'is-not-null';

  export type SetOperator = 'any-of' | 'none-of';

  export type SegmentOperator = 'in-segment' | 'not-in-segment';

  export type RangeOperator = 'between' | 'not-between';

  export type ArrayOperator = 'match-all' | 'match-any';

  export type LikeOperator = 'like' | 'not-like';

  export type RangeSpec = {
    start: Value;
    end: Value;
    startInclusive: boolean;
    endInclusive: boolean;
  };

  export type BinaryExpression = {
    type: 'binary';
    attributeName: string;
    operator: BinaryOperator;
    value: Value;
  };

  export type UnaryExpression = {
    type: 'unary';
    attributeName: string;
    operator: UnaryOperator;
  };

  export type RangeExpression = {
    type: 'range';
    attributeName: string;
    operator: RangeOperator;
    range: RangeSpec;
  };

  export type SetExpression = {
    type: 'set';
    attributeName: string;
    operator: SetOperator;
    values: Value[];
  };

  export type SegmentExpression = {
    type: 'segment';
    operator: SegmentOperator;
    segmentId: string;
  };

  export type LogicalExpression = {
    type: 'logical';
    operator: 'and' | 'or';
    operands: Expression[];
  };

  export type InnerExpression =
    | Omit<BinaryExpression, 'attributeName'>
    | Omit<RangeExpression, 'attributeName'>
    | Omit<SetExpression, 'attributeName'>;

  export type ArrayExpression = {
    type: 'array';
    attributeName: string;
    operator: ArrayOperator;
    rule: InnerExpression;
  };

  export type LikeExpression = {
    type: 'like';
    attributeName: string;
    operator: LikeOperator;
    pattern: string;
  };

  export type Expression =
    | BinaryExpression
    | UnaryExpression
    | RangeExpression
    | SetExpression
    | SegmentExpression
    | LogicalExpression
    | ArrayExpression
    | LikeExpression;

  export const isNullValue = (value: Value): boolean => {
    return value === null;
  };

  export const valueToString = (value: Value): string => {
    if (value === null) {
      return 'null';
    }
    if (typeof value === 'string') {
      return value;
    }
    if (typeof value === 'number') {
      return String(value);
    }
    if (typeof value === 'boolean') {
      return String(value);
    }

    if (typeof value === 'object' && 'version' in value) {
      return value.version;
    }

    return 'null';
  };
}
